export default __webpack_public_path__ + "static/media/contact.131844f4.svg";